import { render, staticRenderFns } from "./Step3ForZmuekish.vue?vue&type=template&id=2e67fcfd&lang=pug"
import script from "./Step3ForZmuekish.vue?vue&type=script&lang=js"
export * from "./Step3ForZmuekish.vue?vue&type=script&lang=js"
import style0 from "./Step3ForZmuekish.vue?vue&type=style&index=0&id=2e67fcfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports